module.exports = __webpack_public_path__ + "static/img/CgoRDGORiQ6AMndGAAyJ8wwBD58029.5649842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGORiQ6AMndGAAyJ8wwBD58029.png
// module id = fqBP
// module chunks = 73